import * as tslib_1 from "tslib";
import { OnDestroy, OnInit, } from '@angular/core';
import { FormBuilder, Validators, } from '@angular/forms';
import { UiModalComponent } from '@components';
import { RolesAssignment, UserType, } from '@models';
import { UserGroupField } from '@pages/users/modals/user-group-import';
import { FoldersService, RoleService, UserService, } from '@services';
import { addToObjectIf } from '@utils/object.utils';
import { BehaviorSubject, of, Subject, } from 'rxjs';
import { filter, finalize, map, startWith, switchMap, take, } from 'rxjs/operators';
var AssignUserModalComponent = /** @class */ (function (_super) {
    tslib_1.__extends(AssignUserModalComponent, _super);
    function AssignUserModalComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.UserType = UserType;
        _this.UserGroupField = UserGroupField;
        _this.loading$ = new BehaviorSubject(false);
        _this.loadingRoles$ = new BehaviorSubject(false);
        _this.isInheritingRolesFromTenant = _this.context.data.folder.rolesAssignment === RolesAssignment.InheritFromTenant;
        _this.isLocalUser = !!_this.context.additionalData.isLocalUser;
        _this.hostClass = 'assign-user-modal';
        _this._fb = _this._injector.get(FormBuilder);
        _this._foldersService = _this._injector.get(FoldersService);
        _this._userService = _this._injector.get(UserService);
        _this._roleService = _this._injector.get(RoleService);
        _this._selectUser$ = new BehaviorSubject(undefined);
        _this._destroyed$ = new Subject();
        _this.userSearchFactory = function (searchTerm, fetchSize, skip) {
            if (fetchSize === void 0) { fetchSize = 20; }
            if (skip === void 0) { skip = 0; }
            return _this._userService.suggest(searchTerm, fetchSize, skip, UserType.User);
        };
        _this.roleSearchFactory = function (searchTerm, fetchSize, skip) {
            if (fetchSize === void 0) { fetchSize = 20; }
            if (skip === void 0) { skip = 0; }
            return _this._roleService.suggest(searchTerm, fetchSize, skip, { useId: true });
        };
        _this._userAlreadyAssignedValidator = function (control) {
            // don't validate on edit
            if (_this.context.data.assignment) {
                return of(null);
            }
            if (!control.value[0]) {
                return of(null);
            }
            var form = control.parent;
            var searchText = _this.isLocalUser
                ? control.value[0].text
                : control.value[0].id + "@" + form.get(UserGroupField.Domain).value[0].id;
            return _this._foldersService
                .checkAssignedUser(_this.context.data.folder.id, searchText)
                .pipe(map(function (assignments) { return assignments ? { alreadyAssigned: assignments } : null; }));
        };
        return _this;
    }
    AssignUserModalComponent.prototype.ngOnInit = function () {
        var _a;
        var _this = this;
        this.form = this._fb.group(tslib_1.__assign((_a = {}, _a[UserGroupField.Domain] = { disabled: this.isLocalUser, value: [] }, _a[UserGroupField.UserName] = [{
                disabled: this.isLocalUser,
                value: [],
            }, {
                asyncValidators: [this._userAlreadyAssignedValidator],
            }], _a[UserGroupField.Type] = { disabled: this.isLocalUser, value: [] }, _a.user = [{
                disabled: !this.isLocalUser,
                value: !!this.context.data.assignment
                    ? [{
                            id: this.context.data.assignment.user.id,
                            text: this.context.data.assignment.user.userName,
                        }]
                    : [],
            }, {
                validators: [Validators.required],
                asyncValidators: [this._userAlreadyAssignedValidator],
            }], _a), addToObjectIf(!this.isInheritingRolesFromTenant, {
            rolesList: [
                !!this.context.data.assignment
                    ? this.context.data.assignment.roles
                        .map(function (role) { return ({
                        id: role.id,
                        text: role.name,
                    }); })
                    : [],
                Validators.required,
            ],
        })));
        if (!!this.context.data.assignment) {
            this.onUserSelected(this.context.data.assignment.user.id);
        }
        this.selectedUser$ = this._selectUser$.pipe(switchMap(function (user) {
            if (!user) {
                _this.loadingRoles$.next(false);
                return of(null);
            }
            _this.loadingRoles$.next(true);
            // we need to emit immediately for Edit
            var status$ = !!_this.context.data.assignment
                ? _this.form.statusChanges.pipe(startWith(_this.form.status))
                : _this.form.statusChanges;
            return status$
                .pipe(filter(function (status) { return status !== 'PENDING'; }), switchMap(function () { return typeof user === 'number'
                ? _this._userService.getInstance(user)
                : _this._foldersService
                    .getAllRolesForUser({ username: user.username + "@" + user.domain, skip: 0, take: 0 })
                    .pipe(map(function (roles) { return ({
                    type: _this.form.get(UserGroupField.Type).value,
                    rolesList: roles.tenantRoles.map(function (role) { return role.name; }),
                }); })); }), finalize(function () { return _this.loadingRoles$.next(false); }), take(1));
        }));
    };
    AssignUserModalComponent.prototype.ngOnDestroy = function () {
        this._destroyed$.next();
        this._destroyed$.complete();
    };
    AssignUserModalComponent.prototype.onUserSelected = function (user) {
        this._selectUser$.next(user);
    };
    AssignUserModalComponent.prototype.switchToEdit = function () {
        var userControls = [this.form.get('user'), this.form.get(UserGroupField.UserName)];
        this.isLocalUser = true;
        // retrieve the already stored user data
        var assignment = userControls.map(function (value) { return value.getError('alreadyAssigned'); }).find(function (value) { return !!value; });
        // update the form and modal to edit state
        this.context.data.assignment = assignment;
        userControls[0].enable();
        userControls[0].patchValue([{
                id: assignment.user.id,
                text: assignment.user.userName,
            }], { onlySelf: true, emitEvent: false });
        this.form.get('rolesList').setValue((assignment.roles || [])
            .map(function (role) { return ({
            id: role.id,
            text: role.name,
        }); }));
        userControls.forEach(function (control) { return control.updateValueAndValidity({ emitEvent: false }); });
    };
    AssignUserModalComponent.prototype.onSubmit = function () {
        var _this = this;
        if (!this.form.valid ||
            this.loading$.value) {
            return;
        }
        this.loading$.next(true);
        var folderId = this.context.data.folder.id;
        var roleIds;
        if (!this.isInheritingRolesFromTenant) {
            roleIds = this.form.value.rolesList
                .map(function (role) { return role.id; });
        }
        if (this.isLocalUser) {
            var userId = this.form.value.user[0].id;
            this._foldersService
                .addUserToFolder(userId, folderId, roleIds)
                .subscribe(function () { return _this._dialogRef.close({
                type: 1 /* Add */,
            }); }, function () { return _this.loading$.next(false); });
        }
        else {
            var userPayload = {
                Domain: this.form.get(UserGroupField.Domain).value[0].id,
                UserName: this.form.get(UserGroupField.UserName).value[0].id,
                UserType: this.form.get(UserGroupField.Type).value,
            };
            this._foldersService
                .addAdEntityToFolder(userPayload, folderId, roleIds)
                .subscribe(function () { return _this._dialogRef.close({
                type: 1 /* Add */,
            }); }, function () { return _this.loading$.next(false); });
        }
    };
    return AssignUserModalComponent;
}(UiModalComponent));
export { AssignUserModalComponent };
